import * as React from 'react';
import { IconProps } from '../types';

const IcSortBy = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
     <path
      fill={props?.fill ?? '#232F3E'}
      fillRule="evenodd"
      d="M5.865 8.467H2.591v-1.5h3.274v1.5Zm16.544 0h-8.761v-1.5h8.761v1.5ZM19.135 15.533h3.274v1.5h-3.274v-1.5Zm-16.544 0h8.761v1.5H2.591v-1.5Z"
      clipRule="evenodd"
    />
    <path
      fill={props?.fill ?? '#232F3E'}
      fillRule="evenodd"
      d="M10.295 9.92a2.204 2.204 0 1 0 0-4.408 2.204 2.204 0 0 0 0 4.407Zm0 1.5a3.704 3.704 0 1 0 0-7.408 3.704 3.704 0 0 0 0 7.407ZM14.705 14.08a2.204 2.204 0 1 0 0 4.408 2.204 2.204 0 0 0 0-4.407Zm0-1.5a3.704 3.704 0 1 0 0 7.408 3.704 3.704 0 0 0 0-7.407Z"
      clipRule="evenodd"
    />
  </svg>
);

export default IcSortBy;